import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { GenerateCvService } from 'src/app/services/generate-cv/generate-cv.service';
import { PaymentService } from 'src/app/services/payment/payment.service';

@Component({
  selector: 'app-scan-linkedin',
  templateUrl: './scan-linkedin.component.html',
  styleUrls: ['./scan-linkedin.component.css'],
})
export class ScanLinkedinComponent {
  services = [
    {
      color: 'blue',
      img: '../../../assets/icon/headline.svg',
      title: 'Headline',
      description: [
        'File format and size',
        'Resume length',
        'Long bullet points with suggestions on how to shorten',
      ],
    },
    {
      color: 'pink',
      img: '../../../assets/icon/summary.svg',

      title: 'Summary',
      description: [
        'Contact information',
        'Essential sections',
        'Personality showcase with tips on how to improve',
      ],
    },
    {
      color: 'blue',
      img: '../../../assets/icon/contact.svg',

      title: 'Contacts',
      description: [
        'ATS parse rate',
        'Repetition of words and phrases',
        'Spelling and grammar',
        'Quantifying impact in experience section with examples',
      ],
    },
    {
      color: 'pink',
      img: '../../../assets/icon/experience.png',

      title: 'Experience',
      description: ['Hard skills', 'Soft skills'],
    },
    {
      color: 'blue',
      img: '../../../assets/icon/educatiion.svg',

      title: 'Education',
      description: [
        'Resume design',
        'Email address',
        'Usage of active voice',
        'Usage of buzzwords and cliches',
      ],
    },
  ];
  steps: MenuItem[] = [];
  activeIndex: any = 0;
  linkedin: any;
  loading: boolean = false;
  constructor(private translate: TranslateService, private cvService: GenerateCvService, private paymentService: PaymentService, private router: Router) {
    this.getTranslate();

    this.translate.onLangChange.subscribe(() => {
      this.getTranslate();
    });
  }
  getTranslate() {
    this.translate
      .get(['Upload LinkedIn', 'Result'])
      .subscribe((translations) => {
        this.steps = [
          { label: translations['Upload LinkedIn'] },

          { label: translations['Result'] },
        ];
      });
  }
  onLinkedinDrop(event: any) {
    event.preventDefault();

    this.linkedin = event.dataTransfer.files[0];

    if (this.linkedin) {
      this.nextStep();
    }
  }

  onLinkedinSelected(event: any) {
    this.linkedin = event.target.files[0];
    if (this.linkedin) {
      this.nextStep();
      this.loading = true;
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }
  nextStep() {
    this.activeIndex = 1;
    this.navigate(this.linkedin);
  }

  navigate(data: any) {
    this.router.navigate(['/scan-linkedin-result'], {
      state: { data },
    });
  }
}
